exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".border-container[data-v-49c36984]{border:1px solid;border-color:#ccc;border-radius:.5rem;overflow:hidden}", ""]);

// exports
